<template>
  <div>
    <div class="fadein">
      <div class="h30"></div>
      <!-- <div class="goback" @click="goback"></div> -->
      <Goback></Goback>

      <div class="gotop" @click="gotop" :hidden="gotopFlag"></div>
      <transition name="el-zoom-in-center">
        <div class="center1200" v-if="movie.title">
          <!-- 电影详情 Start -->
          <div class="bg-white shadow" style="padding:20px;">
            <!-- <div class="title">
                <h2>电影论坛</h2>
            </div> -->
            <div class="h10"></div>
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/movies' }"
                >电影</el-breadcrumb-item
              >
              <el-breadcrumb-item>电影详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="h20"></div>
            <div style="display: flex; justify-content: space-between;">
              <div class="moviepic-big" style="width:300px;">
                <img :src="movie.cover" alt="" class="moviepic-big" />
              </div>
              <div style="width:800px;" class="movieinfo">
                <h2>{{ movie.title }}</h2>
                <p>导演：{{ movie.directors.name }}</p>
                <p>
                  类型：<span v-for="v in movie.withtypes">{{ v.type }} </span>
                </p>
                <p>地区：{{ movie.area }}</p>
                <p>语言：{{ movie.languages }}</p>
                <p>片长：{{ movie.durations }} 分钟</p>
                <p>上映日期：{{ movie.pubdates }}</p>
                <p>又名：{{ movie.aka }}</p>
                <p class="summary">
                  简介：
                  <span v-html="movie.summary"></span>
                </p>
              </div>
            </div>

            <div class="h10"></div>

            <el-badge :value="movie.zan_count" class="item" type="danger">
              <el-button
                :class="likeplain"
                size="small"
                type="danger"
                @click="likeMovie"
                >点赞</el-button
              >
            </el-badge>

            <el-badge :value="movie.like_count" class="item" type="info">
              <el-button
                :class="favplain"
                size="small"
                type="primary"
                @click="favMovie"
                >喜欢</el-button
              >
            </el-badge>

            <el-badge :value="movie.wish_count" class="item" type="success">
              <el-button size="small" :class="wishplain" @click="wishMovie()"
                >想看</el-button
              >
            </el-badge>

            <el-badge :value="movie.reviews_count" class="item" type="primary">
              <el-button size="small" type="primary" plain>热度</el-button>
            </el-badge>
            <div class="h10"></div>
          </div>
          <!-- 电影详情 End -->
          <div class="h20"></div>
          <!-- 电影剧照 Start -->
          <div class="bg-white shadow" style="padding:20px;padding-top:10px">
            <div class="center-title">
              <img class="title-pic" src="/static/img/title-left.png" alt="" />
              剧 照
              <img class="title-pic" src="/static/img/title-right.png" alt="" />
            </div>
            <div class="h20"></div>
            <div class="photos">
              <div class="photo" v-for="v in movie.photos">
                <!-- <a href="" style="display: block;"> -->
                <!-- <img :src="v.movies_photos" alt="" width="100%;" height="100%;"> -->
                <div class="demo-image__preview">
                  <el-image
                    class="img"
                    :src="v.movies_photos"
                    :preview-src-list="[v.movies_photos]"
                    fit="cover"
                  >
                  </el-image>
                </div>
                <!-- </a> -->
              </div>
              <div style="width:270px;" v-for="n in flex_photos_align"></div>
            </div>
          </div>
          <!-- 电影剧照 End -->
          <div class="h20"></div>
          <!-- 演员表 Start -->
          <div class="bg-white shadow" style="padding:20px;padding-top:10px">
            <!-- <el-divider><span class="center-title">演 员 表</span></el-divider> -->
            <div class="center-title">
              <img class="title-pic" src="/static/img/title-left.png" alt="" />
              演 员 表
              <img class="title-pic" src="/static/img/title-right.png" alt="" />
            </div>
            <div class="h20"></div>
            <div class="movieboxes">
              <div class="moviebox" v-for="(v, k) in movie.withactors">
                <a href="javascript:;" @click="actorDetail(v.id)">
                  <!-- <div class="moviepicbox">
                            <img :src="v.actor_pic" alt="" class="moviepic" />
                        </div> -->
                  <el-image
                    style="width: 170px; height: 250px"
                    :src="v.actor_pic"
                    fit="cover"
                  ></el-image>
                </a>
                <a href="javascript:;" @click="actorDetail(v.id)">{{
                  v.name
                }}</a>
                <p>{{ v.jobs }}</p>
              </div>
              <div style="width:170px;" v-for="n in flex_actors_align"></div>
            </div>
          </div>
          <!-- 演员表 End -->
          <div id="test_enter"></div>
          <div class="h20"></div>
          <!-- 影评 Start -->
          <div class="bg-white shadow" style="padding:20px;padding-top:10px">
            <div class="center-title">
              <img class="title-pic" src="/static/img/title-left.png" alt="" />
              影评
              <img class="title-pic" src="/static/img/title-right.png" alt="" />
            </div>
            <div class="h20"></div>
            <div style="width:1100px;margin:0 auto;">
              <span v-if="get_user_info.level == 0">
                <span
                  >在用户首次评论之前，需要填写一份简单的问卷，以达到活跃用户素质的目的；若用户没能完成我们设计的问题，则只能浏览和参与（投票），无法发表言论。我们希望为热爱电影的人群创建一片交流相处的净土，感谢配合
                  ヾ(o◕∀◕)~</span
                ><br /><br />
                <div style="text-align: center;">
                  <el-button type="primary" @click="goTest()">GO~</el-button>
                </div>
              </span>
              <span v-else-if="user_id != null">
                <el-input
                  class="content"
                  type="textarea"
                  :autosize="{ minRows: 5 }"
                  placeholder="发表一个友善的评论吧~"
                  v-model="content"
                >
                </el-input>
                <div style="text-align:center;">
                  <el-button
                    type="primary"
                    style="width:120px;"
                    @click="publishContent()"
                    >发 布</el-button
                  >
                </div>
              </span>

              <span v-else>
                <div style="text-align:center;">
                  登录后才能参与讨论呀~<br /><br />
                  <router-link to="/login">
                    <el-button type="primary" style="width:120px;"
                      >登 录</el-button
                    >
                  </router-link>
                </div>
              </span>

              <div v-for="(v, k) in contents" class="comment-box">
                <div
                  style="display: flex;justify-content: space-between;  flex-direction: row;"
                >
                  <div v-if="v.level == 1"></div>
                  <div v-else style="width:50px;height:80px;"></div>
                  <div style="width:100%;">
                    <el-divider></el-divider>
                    <!-- 用户没有完善资料 -->
                    <span
                      v-if="
                        v.user_info.extras.user_pic == 'http://' + $API_URL + ''
                      "
                    >
                      <img
                        src="/static/img/default_userpic.png"
                        alt=""
                        class="comment-head"
                        @click="goUserinfo(v.user_id)"
                      />
                    </span>
                    <span v-else>
                      <img
                        :src="v.user_info.extras.user_pic"
                        alt=""
                        class="comment-head"
                        @click="goUserinfo(v.user_id)"
                      />
                    </span>

                    <!-- 用户完善了资料 -->
                    <span v-if="v.user_info.extras.nickname == null">
                      <div class="comment-title" @click="goUserinfo(v.user_id)">
                        {{ v.user_info.mobile }}
                      </div>
                    </span>
                    <span v-else>
                      <div class="comment-title" @click="goUserinfo(v.user_id)">
                        {{ v.user_info.extras.nickname }}
                      </div>
                    </span>
                    <!-- <img style="vertical-align: middle;" src="/static/img/lv/LV0.png" alt="" v-if="v.userinfo.level==0"><img style="vertical-align: middle;" src="/static/img/lv/LV1.png" alt="" v-if="v.userinfo.level==1"><img style="vertical-align: middle;" src="/static/img/lv/LV2.png" alt="" v-if="v.userinfo.level==2"><img style="vertical-align: middle;" src="/static/img/lv/LV3.png" alt="" v-if="v.userinfo.level==3"><img style="vertical-align: middle;" src="/static/img/lv/LV4.png" alt="" v-if="v.userinfo.level==4"><img style="vertical-align: middle;" src="/static/img/lv/LV5.png" alt="" v-if="v.userinfo.level==5"> -->
                    <div style="clear: both;"></div>
                    <div class="comment-body">
                      <a
                        style="color:#ff7400;cursor: pointer;"
                        @click="goUserinfo(v.reply_user_info.id)"
                        v-if="v.reply_user_info.nickname != ''"
                        >@{{ v.reply_user_info.nickname }}</a
                      >
                      <a
                        style="color:#ff7400;cursor: pointer;"
                        @click="goUserinfo(v.reply_user_info.id)"
                        v-else-if="v.reply_user_info.mobile != ''"
                        >@{{ v.reply_user_info.mobile }}</a
                      >

                      {{ v.content }}
                    </div>
                    <div class="actions">
                      <div v-if="v.user_info.extras.is_zan == 1">
                        <div
                          class="like-active"
                          @click="zanComment(v.id)"
                        ></div>
                        <span>{{ v.zan_num }}</span>
                      </div>
                      <div v-else>
                        <div class="like" @click="zanComment(v.id)"></div>
                        <span>{{ v.zan_num }}</span>
                      </div>
                      <div class="reply" @click="showReply(k)"></div>
                      <div class="created-at">
                        <span v-if="user_id == v.user_id"
                          ><a href="javascript:;" @click="deleteComment(v.id)"
                            >删除评论</a
                          ></span
                        >
                        <span
                          v-else
                          style="margin-top:-10px;margin-right: 5px;"
                        >
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="举报此评论"
                            placement="top"
                            style="margin-right:0px;"
                          >
                            <div
                              class="report"
                              @click="
                                showDialogReport(
                                  v.id,
                                  v.user_info.extras.nickname,
                                  v.content
                                )
                              "
                              v-if="v.user_info.extras.nickname != null"
                            ></div>
                            <div
                              class="report"
                              @click="
                                showDialogReport(
                                  v.id,
                                  v.user_info.mobile,
                                  v.content
                                )
                              "
                              v-else
                            ></div>
                          </el-tooltip>
                        </span>
                        <span>发布日期：{{ v.created_at }}</span>
                      </div>
                      <!-- <div class="fav"></div> -->
                    </div>

                    <!-- 显示顶级回复框 Start -->
                    <div class="hiddencontent" :ref="k">
                      <div class="h20"></div>
                      <span v-if="get_user_info.level == 0">
                        <br />
                        <span
                          >在用户首次评论之前，需要填写一份简单的问卷，以达到活跃用户素质；若用户没能完成我们设计的问题，则只能浏览和参与（投票），无法发表言论。我们希望为热爱电影的人群创建一片交流相处的净土，感谢配合
                          ヾ(o◕∀◕)~</span
                        ><br /><br />
                        <div style="text-align: center;">
                          <el-button type="primary" @click="goTest()"
                            >GO~</el-button
                          >
                        </div>
                      </span>
                      <span v-else-if="user_id != null">
                        <el-input
                          class="content"
                          type="textarea"
                          :autosize="{ minRows: 5 }"
                          placeholder="回复一个友善的评论吧~"
                          v-model="son_content"
                        >
                        </el-input>
                        <div style="text-align:center;">
                          <el-button
                            type="primary"
                            style="width:120px;"
                            @click="son_publishContent(v.id)"
                            >回 复</el-button
                          >
                        </div>
                      </span>
                      <span v-else>
                        <br />
                        <div style="text-align:center;">
                          登录后才能参与讨论呀~<br /><br />
                          <router-link to="/login">
                            <el-button type="primary" style="width:120px;"
                              >登 录</el-button
                            >
                          </router-link>
                        </div>
                      </span>
                    </div>
                    <!-- 显示顶级回复框 End -->
                  </div>
                </div>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
          <!-- 影评 End -->
          <!-- 举报评论 Start -->
          <el-dialog title="举报评论" :visible.sync="dialog_report_visible">
            <el-form :model="form">
              <el-form-item
                label="举报的用户为："
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="form.report_nickname"
                  autocomplete="off"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="违规行为：" :label-width="formLabelWidth">
                <!-- <el-select v-model="form.report_type" placeholder="请选择违规行为">
                      <el-option label="口头谩骂" value="口头谩骂"></el-option>
                      <el-option label="区域二" value="beijing"></el-option>
                    </el-select> -->
                <el-radio-group
                  v-model="form.report_reason"
                  style="line-height: 40px;margin-top:5px;"
                >
                  <el-radio label="违法违规">违法违规</el-radio>
                  <el-radio label="色情低俗">色情低俗</el-radio>
                  <el-radio label="赌博诈骗">赌博诈骗</el-radio>
                  <el-radio label="人身攻击">人身攻击</el-radio>
                  <el-radio label="侵犯隐私">侵犯隐私</el-radio>
                  <el-radio label="垃圾广告">垃圾广告</el-radio>
                  <el-radio label="不明链接">不明链接</el-radio>
                  <el-radio label="引战">引战</el-radio>
                  <el-radio label="剧透">剧透</el-radio>
                  <el-radio label="刷屏">刷屏</el-radio>
                  <el-radio label="抢楼">抢楼</el-radio>
                  <el-radio label="内容不相关">内容不相关</el-radio>
                  <el-radio label="其他">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="举报原因：" :label-width="formLabelWidth">
                <el-input
                  type="textarea"
                  placeholder="请说明举报原因"
                  v-model="form.report_content"
                  maxlength="100"
                  :autosize="{ minRows: 5 }"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialog_report_visible = false"
                >取 消</el-button
              >
              <el-button type="info" @click="sendReport()">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 举报评论 End -->
        </div>
      </transition>
      <div class="h30"></div>
    </div>
  </div>
</template>
<script>
import Goback from "@/components/components/goback";
export default {
  data() {
    return {
      movie: {
        title: "",
        directors: {
          name: ""
        }
      },
      //是否显示回到顶部的图标
      gotopFlag: true,
      //电影id
      id: 0,
      //演员id
      aid: 0,
      //电影点赞
      movie_like_count: 0,

      //评论列表展示的数据
      contents: [],

      //用户评论内容（顶级）
      content: "",

      //子级评论
      son_content: "",

      //显示子级评论框
      showContent: false,

      //电影like的样式
      likeplain: "likeplain",
      //电影喜欢的样式
      favplain: "favplain",
      //电影想看样式
      wishplain: "wishplain",

      //dialog举报
      dialog_report_visible: false,
      form: {
        report_cid: 0,
        report_comment: "",
        report_nickname: "",
        report_reason: "",
        report_content: ""
      },
      formLabelWidth: "120px",

      //判断用户是否登录
      islogin: false,
      user_id: null,

      //演员flex的格式补齐
      flex_actors_align: 0,

      //剧照flex的格式补齐
      flex_photos_align: 0,

      //评论回复按钮状态
      comment_reply_statu: "reply",

      //当前登录的用户信息
      get_user_info: {},

      //锚点
      isback: false
    };
  },
  updated() {
    if (this.isback) {
      setTimeout(() => {
        // console.log(this.isback)
        // console.log('updated')
        this.getUserinfo();
        this.goSelfComment();
        this.isback = false;
      }, 250);
    }
  },
  watch: {
    //路由改变时执行
    $route(newVal, oldVal) {
      this.movie = {};

      if (oldVal.name == "test") {
        this.getUserinfo();
        this.isback = true;
        console.log(this.isback);
      }
      //路由改变时触发电影id的改变
      if (newVal.name == "movie") {
        // console.log(newVal.name)
        this.$parent.activeIndex = "2";
        // console.log(this.$parent.activeIndex)
        this.getUserinfo();
        //路由跳转到电影详情页面时触发id监视器
        this.id = this.$route.params.id;
        //路由跳转到电影详情页面时获取该用户是否点赞
        var user_id = localStorage.getItem("token");
        this.judgeLike();
        this.judgeFav();
        //获取电影信息
        this.getMovieDetail();
        //获取电影评论
        this.getMovieContents();
      }
      if (oldVal.name == "movie") {
        this.scrollTop = 0;
      }
    }
  },
  mounted() {
    this.$parent.activeIndex = "2";
    this.getUserinfo();
    this.isLogin();
    this.user_id = localStorage.getItem("token");
    this.id = this.$route.params.id;

    //
    if (this.movie.title == "") {
      //获取用户是否点赞该电影
      this.judgeLike();

      //获取用户是否喜欢该电影
      this.judgeFav();

      //获取电影信息
      this.getMovieDetail();

      //获取电影评论
      this.getMovieContents();
    }
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    //答完题后的锚点跳转
    goSelfComment() {
      console.log(111);
      $("html, body").animate({ scrollTop: $("#test_enter").offset().top }, 0);
    },
    // 判断用户是否登录
    isLogin() {
      if (!localStorage.getItem("token")) {
        // this.$message({
        //     showClose:true,
        //     message:"请先登录~",
        //     type:"warning"
        // })
        // this.$router.push('/login');
        this.islogin = false;
      } else {
        this.islogin = true;
      }
    },
    // 查看演员详情
    actorDetail(aid) {
      //
      this.$router.push("/actor/" + aid);
    },

    //获取电影信息
    getMovieDetail() {
      //获取电影
      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/movies/" + this.id,
        type: "get",
        success: ret => {
          this.movie = ret;
          //
          //
          this.flex_actors_align = 6 - (this.movie.withactors.length % 6);
          //
          this.flex_photos_align = 4 - (this.movie.photos.length % 4);
        }
      });
    },
    // //返回
    // goback(){
    //     this.$router.go(-1);
    // },
    // 回到顶部
    gotop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 1);
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 500) {
        //   that.gotopFlag = false
        $(".gotop").fadeIn(500);
      } else {
        //   that.gotopFlag = true
        $(".gotop").fadeOut(500);
      }
    },

    //判断用户是否点赞该电影
    judgeLike() {
      $.ajax({
        url:
          "//" + this.$API_URL + "/api/v1/movies/is_zan_movie/" + this.id,
        type: "post",
        data: { user_id: localStorage.getItem("token") },
        success: ret => {
          //
          if (ret.code == 200) {
            this.likeplain = "likeplain-at";
          } else {
            this.likeplain = "likeplain";
          }
        }
      });
    },
    //判断用户是否喜欢该电影
    judgeFav() {
      $.ajax({
        url:
          "//" + this.$API_URL + "/api/v1/movies/is_like_movie/" + this.id,
        type: "post",
        data: { user_id: localStorage.getItem("token") },
        success: ret => {
          if (ret.code == 200) {
            this.favplain = "favplain-at";
          } else {
            this.favplain = "favplain";
          }
        }
      });
    },

    //用户点赞
    zanComment(cid) {
      if (!localStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: '需要登录呀~ (￣▽￣")',
          type: "warning"
        });
        return false;
      }
      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/comments/zan/" + cid,
        type: "post",
        data: { user_id: this.user_id },
        success: ret => {
          this.$message({
            showClose: true,
            message: ret.msg,
            type: "success"
          });
          this.getMovieContents();
        }
      });
    },

    //电影点赞与取消点赞
    likeMovie() {
      if (!localStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: '需要登录呀~ (￣▽￣")',
          type: "warning"
        });
        return false;
      }
      if (this.likeplain == "likeplain") {
        //没有点赞 => 点赞
        this.likeplain = "likeplain-at";
        // this.movie.like_count += 1
        this.movie.zan_count += 1;
      } else {
        //点赞 => 没点赞
        this.likeplain = "likeplain";
        // this.movie.like_count -= 1
        this.movie.zan_count -= 1;
      }

      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/movies/zan/" + this.id,
        type: "post",
        data: { user_id: localStorage.getItem("token") },
        success: ret => {
          this.$message({
            showClose: true,
            message: ret.msg,
            type: "success",
            duration: 1000
          });
        }
      });
    },

    //电影喜欢与取消喜欢
    favMovie() {
      if (!localStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: '需要登录呀~ (￣▽￣")',
          type: "warning"
        });
        return false;
      }
      if (this.favplain == "favplain") {
        //没有点赞 => 点赞
        this.favplain = "favplain-at";
        this.movie.like_count += 1;
      } else {
        //点赞 => 没点赞
        this.favplain = "favplain";
        this.movie.like_count -= 1;
      }

      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/movies/like/" + this.id,
        type: "post",
        data: { user_id: localStorage.getItem("token") },
        success: ret => {
          this.$message({
            showClose: true,
            message: ret.msg,
            type: "success",
            duration: 1000
          });
        }
      });
    },

    //电影想看
    wishMovie() {
      if (!localStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: '需要登录呀~ (￣▽￣")',
          type: "warning"
        });
        return false;
      }
      if (this.wishplain == "wishplain") {
        //没有点赞 => 点赞
        this.wishplain = "wishplain-at";
        this.movie.wish_count += 1;
      } else {
        //点赞 => 没点赞
        this.wishplain = "wishplain";
        this.movie.wish_count -= 1;
      }

      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/movies/wish/" + this.id,
        type: "post",
        data: { user_id: localStorage.getItem("token") },
        success: ret => {
          this.$message({
            showClose: true,
            message: ret.msg,
            type: "success",
            duration: 1000
          });
        }
      });
    },

    //评论发布（顶级）
    publishContent() {
      //
      if (this.content.length < 5) {
        this.$message({
          showClose: true,
          message: "至少评论5个字呀~  Σ( ° △ °|||)︴ ",
          type: "error"
        });
        return false;
      }
      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/comments/create",
        type: "post",
        data: {
          movie_id: this.id,
          user_id: localStorage.getItem("token"),
          pid: 0,
          content: this.content
        },
        success: ret => {
          if (ret.code == 400) {
            this.$message({
              showClose: true,
              message: ret.msg,
              type: "warning"
            });
            this.$router.push("/test");
            return false;
          }
          if (ret.code == 201) {
            this.$message({
              showClose: true,
              message: ret.msg,
              type: "success"
            });
            this.content = "";
          } else {
            this.$message({
              showClose: true,
              message: ret.data.content[0],
              type: "error"
            });
          }
          this.getMovieContents();
        }
      });
    },

    //显示/隐藏回复框
    showReply(k) {
      // this.showContent = !this.showContent
      //

      //只允许同时打开一个回复框
      if (!localStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: '需要登录呀~ (￣▽￣")',
          type: "warning"
        });
        return false;
      }
      //获取点击的标签
      var tag = this.$refs[k];

      //获取点击的标签的样式
      var clas = $(tag).attr("class");
      //
      if (clas == "hiddencontent") {
        $(".showcontent").attr("class", "hiddencontent");
        $(".reply-active").attr("class", "reply");

        // event.attr('class','reply-active')

        $(tag)
          .parent()
          .find(".reply")
          .attr("class", "reply-active");
        //
        $(tag).attr("class", "showcontent");
      } else {
        $(tag)
          .parent()
          .find(".reply-active")
          .attr("class", "reply");

        $(tag).attr("class", "hiddencontent");
      }
      //
      //
    },

    //子级评论回复
    son_publishContent(pid) {
      if (this.son_content.length < 5) {
        this.$message({
          showClose: true,
          message: "至少评论5个字呀~  Σ( ° △ °|||)︴ ",
          type: "error"
        });
        return false;
      }
      //需要8个参数
      //1、电影id
      var movie_id = this.id;
      //2、用户id
      var user_id = localStorage.getItem("token");
      //4、评论的内容
      var content = this.son_content;

      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/comments/create",
        type: "post",
        data: {
          movie_id,
          user_id,
          content,
          pid
        },
        success: ret => {
          if (ret.code == 201) {
            this.$message({
              showClose: true,
              message: ret.msg,
              type: "success"
            });
            $(".reply-active").attr("class", "reply");
            $(".showcontent").attr("class", "hiddencontent");
            this.son_content = "";

            this.getMovieContents();
          } else {
            this.$message({
              showClose: true,
              message: ret.data.content[0],
              type: "error"
            });
          }
        }
      });
    },

    //获取电影评论
    getMovieContents() {
      if (localStorage.getItem("token")) {
        $.ajax({
          url:
            "//" +
            this.$API_URL +
            "/api/v1/comments/movies/" +
            this.id +
            "?uid=" +
            localStorage.getItem("token"),
          type: "get",
          success: ret => {
            //
            if (ret.code == 200) {
              this.contents = ret.data;
            }
          }
        });
      } else {
        $.ajax({
          url: "//" + this.$API_URL + "/api/v1/comments/movies/" + this.id,
          type: "get",
          success: ret => {
            //
            if (ret.code == 200) {
              this.contents = ret.data;
            }
          }
        });
      }
    },

    //点击用户名或头像跳转到用户信息页
    goUserinfo(uid) {
      this.$router.push("/user/" + uid).catch(err => {
        err;
      });
    },

    //读取当前用户的信息
    getUserinfo() {
      if (localStorage.getItem("token") == null) {
        return false;
      }
      $.ajax({
        url:
          "//" +
          this.$API_URL +
          "/api/v1/user_info/" +
          localStorage.getItem("token"),
        type: "get",
        success: ret => {
          this.get_user_info = ret.data;
        }
      });
    },

    //去Test页面
    goTest() {
      // console.log(document.location);
      this.$router.push("/test").catch(err => {
        err;
      });
    },

    //删除自己的评论
    deleteComment(id) {
      this.$confirm("此操作将删除该评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.ajax({
            url:
              "//" +
              this.$API_URL +
              "/api/v1/comments/delete_self_comments/" +
              id,
            type: "post",
            data: { user_id: localStorage.getItem("token") },
            success: ret => {
              if (ret.code == 204) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.getMovieContents();
              } else {
                this.$message({
                  type: "info",
                  message: "该评论已不存在!"
                });
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //显示举报评论对话框
    showDialogReport(id, nickname, comment) {
      if (localStorage.getItem("token") == null) {
        this.$message({
          showClose: true,
          message: "请先登录~",
          type: "info"
        });
        return false;
      }
      if (this.form.report_cid != id) {
        this.form.report_cid = id;
        this.form.report_reason = "";
        this.form.report_content = "";
      }
      this.form.report_nickname = nickname;
      this.form.report_comment = comment;

      this.dialog_report_visible = true;
    },
    //发送举报
    sendReport() {
      if (this.form.report_reason == "") {
        this.$message({
          showClose: true,
          message: "请选择违规行为",
          type: "info"
        });
        return false;
      }
      $.ajax({
        url:
          "//" +
          this.$API_URL +
          "/api/v1/comments/report_comment/" +
          this.form.report_cid,
        type: "post",
        data: {
          report_user_id: localStorage.getItem("token"),
          reasons: this.form.report_reason,
          content: this.form.report_content
        },
        success: ret => {
          //
          // if(ret.code==200){
          this.$message({
            showClose: true,
            message: ret.msg,
            type: "info"
          });
          this.dialog_report_visible = false;
          // }
        }
      });
    }
  },
  components: {
    Goback
  }
};
</script>
<style scoped>
.movieinfo p {
  height: 30px;
  line-height: 30px;
}
.likeplain {
  color: #ff2b78;
  background: #ffeaf2;
}
.likeplain-at {
  color: #ffeaf2;
  background: #ff2b78;
}
.favplain {
  color: #ae53b1;
  background: #ffedff;
  border: 1px solid #be84c0;
}
.favplain-at {
  color: #ffedff;
  background: #ae53b1;
  border: 1px solid #ae53b1;
}

.wishplain {
  color: #00ab6f;
  background: #e6f7f1;
  border: 1px solid #63d4af;
}
.wishplain-at {
  color: #e6f7f1;
  background: #00ab6f;
  border: 1px solid #00ab6f;
}
.item {
  margin-top: 10px;
  margin-right: 20px;
}
.summary {
  width: 780px;
  height: auto;
}
.summary span {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  height: auto;
  height: 210px;
}

.photos {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.photo {
  width: 270px;
  height: 150px;
  background: #fff;
  margin-bottom: 20px;
  text-align: center;
  box-shadow: 0px 0px 10px #ccc;
  transition: 0.5s;
}
.photo:hover {
  background: #303133;
  box-shadow: 0px 0px 20px #303133;
  transition: 0.5s;
}
.photo .img {
  width: 270px;
  height: 150px;
  /* max-width:270px;
    max-height: 150px;
    width:auto;
    height:auto; */
}
.comment-head {
  cursor: pointer;
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  vertical-align: middle;
  border: 1px solid #ccc;
  float: left;
  margin-right: 10px;
}

.hiddencontent {
  display: none;
}
.showcontent {
  padding: 0 50px;
  display: block;
}
.son-hiddencontent {
  display: none;
}
.son-showcontent {
  display: block;
}
.comment-title {
  cursor: pointer;
  font-size: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.comment-body {
  padding: 10px 10px 10px 50px;
}
.son-content {
  padding-left: 50px;
}
.content {
  margin-top: 20px;
  margin-bottom: 20px;
}
.actions {
  /* display: flex; */
  margin-top: 10px;
  margin-left: 48px;
  justify-content: space-between;
  /* width:120px; */
  /* width:250px; */
}
.actions span {
  float: left;
  line-height: 30px;
  margin-right: 20px;
}
.like {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  background-image: url("/static/icon/like.png");
}
.like:hover {
  opacity: 0.5;
  background-image: url("/static/icon/like_at.png");
}

.like-active {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  background-image: url("/static/icon/like_at.png");
}
/*
.fav{
    cursor:pointer;
    width:30px;
    height:30px;
    background-image:url('/static/icon/fav.png');
}
.fav:hover{
    opacity:0.5;
    background-image:url('/static/icon/fav_at.png');
}
.fav:active{
    opacity:1;
    background-image:url('/static/icon/fav_at.png');
}*/
.reply {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  background-image: url("/static/icon/reply.png");
}
.reply:hover {
  opacity: 0.5;
  background-image: url("/static/icon/reply_at.png");
}
.reply-active {
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  background-image: url("/static/icon/reply_at.png");
}
.created-at {
  float: right;
  line-height: 30px;
  font-size: 14px;
  color: #666;
}
.created-at a {
  margin-right: 5px;
  color: #999;
  text-decoration: none;
}
.created-at a:hover {
  color: #ff2b78;
}
.created-at span {
  /* float: left; */
  /* line-height: 30px; */
  margin-right: 10px;
}
.report {
  text-align: center;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-top: 15px;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-image: url("/static/icon/report.png");
  background-size: 20px 20px;
}
.report:hover {
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid red;
  background-image: url("/static/icon/report_at.png");
}
</style>



// WEBPACK FOOTER //
// src/components/index/movie.vue